export const MAX_DEPARTURES_DISPLAYED_COUNT = 3;